export default function Flower({ className = "w-10 h-10", petals = "#E85D9E", center = "#E3B341", count = 8 }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <ellipse
          key={i}
          cx="50"
          cy="25"
          rx="12"
          ry="21"
          fill={petals}
          transform={`rotate(${(360 / count) * i} 50 50)`}
        />
      ))}
      <circle cx="50" cy="50" r="14" fill={center} />
      <circle cx="46" cy="46" r="2.2" fill="#2A2118" opacity="0.25" />
      <circle cx="55" cy="47" r="2.2" fill="#2A2118" opacity="0.25" />
      <circle cx="50" cy="55" r="2.2" fill="#2A2118" opacity="0.25" />
    </svg>
  );
}
